'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import utils from 'services/utils';
import classNames from 'classnames';
import _ from 'underscore';

import 'styles/PopoverContent.scss';


const propTypes = {
    heading:  PropTypes.string,
    content: PropTypes.object,
    noContentPadding: PropTypes.bool, //Used when the content is a regular component. Gabs.
};

class PopoverContent extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div className={classNames("popover-content", {"no-content-padding":this.props.noContentPadding})}>
                {this.props.heading ? <h4>{this.props.heading}</h4> : null}
                {this.props.children}
            </div>
        );
    }
}

PopoverContent.propTypes = propTypes;
export default PopoverContent;